import { render, staticRenderFns } from "./CathayPropertyFireInsurance.vue?vue&type=template&id=a07dba4a"
import script from "./CathayPropertyFireInsurance.vue?vue&type=script&lang=js"
export * from "./CathayPropertyFireInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports